import { Button, HStack } from '@montel/montelpro-shared-components-v2';
import { useAssignToCompanyFormContext } from 'components/companies/AssignToCompanyForm/AssignToCompanyFormContext';
import { RequestStatus } from 'types/RequestStatus';

export const ReviewAndAssignToCompanyFooter: React.FunctionComponent<{
	onSubmitted: () => void;
	onCloseModal: () => void;
	postAssignAndMarkReviewedStatus: RequestStatus;
}> = ({ onSubmitted, onCloseModal, postAssignAndMarkReviewedStatus }) => {
	const { selectedCompany } = useAssignToCompanyFormContext();

	return (
		<HStack gap="md">
			<Button
				text={'Assign user and mark as reviewed'}
				size="md"
				type="submit"
				isLoading={
					postAssignAndMarkReviewedStatus === RequestStatus.LOADING
				}
				loadingText="Updating..."
				onClick={onSubmitted}
				isDisabled={
					!selectedCompany ||
					postAssignAndMarkReviewedStatus === RequestStatus.LOADING
				}
			/>
			<Button
				text="Cancel"
				size="md"
				variant="secondary"
				onClick={onCloseModal}
			/>
		</HStack>
	);
};
